export default __webpack_public_path__ + "static/media/sobre_footer.a1450c73.svg";